import axios from '@/plugins/axios';

const fileManagerService = {
  /**
   * Subir un archivo al servidor.
   * @param {File} file - El archivo a subir.
   * @param {string|number} viewId - El ID de la vista o button_link.
   * @param {Object} fileData - Datos adicionales del archivo (ubicación, etc.).
   * @returns {Promise} - La respuesta de la API.
   */
  uploadFile(file, viewId = null, fileData) {
    const formData = new FormData();
    console.log('fileManagerService - viewId:', viewId);
    formData.append('file', file);
    formData.append('fileName', file.name);
    
    // Obtener la extensión del archivo
    const fileExtension = file.name.split('.').pop().toLowerCase();
    formData.append('fileExtension', fileExtension);
    
    if (viewId) {
      // Compatibilidad: algunos endpoints lo esperan como viewId
      formData.append('viewId', viewId);
      // Backend actual espera button_link_id
      formData.append('button_link_id', viewId);
    }
    
    if (fileData) {
      formData.append('fileData', JSON.stringify(fileData));
    }

    return axios.post('/file-manager', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Eliminar un archivo del servidor.
   * @param {string} path - La ruta del archivo a eliminar.
   * @param {string|number} viewId - El ID de la vista o button_link.
   * @param {string} fileName - El nombre del archivo a eliminar.
   * @param {string} fileExtension - La extensión del archivo a eliminar.
   * @param {string|number} fileId - El ID de la API del archivo a eliminar.
   * @returns {Promise} - La respuesta de la API.
   */
  deleteFile(path, viewId, fileName, fileExtension, fileId = null) {

    const data = { path, viewId, fileName, fileExtension, fileId };
    
    // Agregar el ID del archivo si está disponible
    if (fileId) {
      data.fileId = fileId;
    }
    
    console.log('Enviando datos para eliminar archivo:', data);
    
    return axios.delete('/file-manager', {
      data,
    });
  },
};

export default fileManagerService;
